module.exports = __webpack_public_path__ + "static/media/user1.659b0144.gif";